interface CssKeyOptions {
  useDraft?: boolean;
  withStyle?: string | false;
  withTheme?: string;
  baseline?: string;
  embedd?: boolean;
}

export const styleKeys = {
  styleAll: ['STYLE'] as const,
  style: (organization: unknown, documentRevisionId: string | undefined, styleId: string | undefined) => ['STYLE', organization, documentRevisionId, styleId],
  stylesAll: ['STYLES'] as const,
  styles: (organization: unknown, documentRevisionId: string | undefined, styleIds: (string | undefined)[]) => [
    'STYLES',
    organization,
    documentRevisionId,
    ...styleIds,
  ],
  cssAll: ['CSS'] as const,
  css: (documentSuperId: number | string, documentRevisionId: string | undefined, { useDraft, withStyle, withTheme, baseline, embedd }: CssKeyOptions) => [
    'CSS',
    documentSuperId,
    documentRevisionId,
    { useDraft, withStyle, withTheme, baseline, embedd },
  ],
};
